import styles from './loading.module.scss';
const WS_TYPE_ROWS = 5;
const NEARBY_CARDS = 4;
const BRAND_LOGOS = 6;
export default function HomeLoading() {
  return <div className={styles.root} role="status" aria-live="polite" aria-label="Loading home" data-sentry-component="HomeLoading" data-sentry-source-file="loading.tsx">
            {/* Hero — mirrors HomeHero (full-bleed dark hero with title + search) */}
            <section className={styles.hero} aria-hidden="true">
                <div className={styles.heroContent}>
                    <div className={styles.heroHeading}>
                        <div className={`${styles.shimmerDark} ${styles.heroLine} ${styles.heroLine1}`} />
                        <div className={`${styles.shimmerDark} ${styles.heroLine} ${styles.heroLine2}`} />
                    </div>
                    <div className={`${styles.shimmer} ${styles.heroSearch}`} />
                    <div className={styles.heroAppRow}>
                        <span className={`${styles.shimmerDark} ${styles.heroAppPill}`} />
                        <span className={`${styles.shimmerDark} ${styles.heroAppPill}`} />
                    </div>
                </div>
            </section>

            {/* Brands strip — mirrors Brands (centered title + marquee logos) */}
            <section className={styles.brands} aria-hidden="true">
                <div className={`${styles.shimmer} ${styles.brandsTitle}`} />
                <div className={styles.brandsRow}>
                    {Array.from({
          length: BRAND_LOGOS
        }).map((_, i) => <span key={i} className={`${styles.shimmer} ${styles.brandsLogo}`} />)}
                </div>
            </section>

            {/* Workspace types — mirrors WorkspaceTypesSection (5 rows + image) */}
            <section className={styles.wsTypes} aria-hidden="true">
                <div className={styles.sectionHeading}>
                    <span className={`${styles.shimmer} ${styles.sectionEyebrow}`} />
                    <span className={`${styles.shimmer} ${styles.sectionTitle}`} />
                </div>
                <div className={styles.wsTypesContent}>
                    <div className={styles.wsTypesList}>
                        {Array.from({
            length: WS_TYPE_ROWS
          }).map((_, i) => <div key={i} className={styles.wsTypeRow}>
                                <span className={`${styles.shimmer} ${styles.wsTypeIcon}`} />
                                <div className={styles.wsTypeText}>
                                    <span className={`${styles.shimmer} ${styles.wsTypeNum}`} />
                                    <span className={`${styles.shimmer} ${styles.wsTypeTitle}`} />
                                </div>
                                <span className={`${styles.shimmer} ${styles.wsTypeArrow}`} />
                            </div>)}
                    </div>
                    <div className={`${styles.shimmer} ${styles.wsTypeImage}`} />
                </div>
            </section>

            {/* Explore nearby — mirrors ExploreNearbySection (4 small listing cards) */}
            <section className={styles.nearby} aria-hidden="true">
                <div className={styles.sectionHeadingCenter}>
                    <span className={`${styles.shimmer} ${styles.sectionTitleLg}`} />
                    <span className={`${styles.shimmer} ${styles.sectionSubtitle}`} />
                </div>
                <div className={styles.nearbyGrid}>
                    {Array.from({
          length: NEARBY_CARDS
        }).map((_, i) => <div key={i} className={styles.nearbyCard}>
                            <div className={`${styles.shimmer} ${styles.nearbyImage}`} />
                            <div className={styles.nearbyBody}>
                                <span className={`${styles.shimmer} ${styles.nearbyTitle}`} />
                                <span className={`${styles.shimmer} ${styles.nearbyMeta}`} />
                                <span className={`${styles.shimmer} ${styles.nearbyPrice}`} />
                            </div>
                        </div>)}
                </div>
                <div className={`${styles.shimmer} ${styles.seeMore}`} />
            </section>

            {/* Long term lease — mirrors LongTermLeaseSection (image + cards) */}
            <section className={styles.lease} aria-hidden="true">
                <div className={styles.sectionHeadingCenter}>
                    <span className={`${styles.shimmer} ${styles.sectionTitleLg}`} />
                    <span className={`${styles.shimmer} ${styles.sectionSubtitle}`} />
                </div>
                <div className={styles.leaseContent}>
                    <div className={`${styles.shimmer} ${styles.leaseImage}`} />
                    <div className={styles.leaseColumn}>
                        <div className={styles.leaseCard}>
                            <span className={`${styles.shimmer} ${styles.leaseCardTitle}`} />
                            <span className={`${styles.shimmer} ${styles.leaseCardLine}`} />
                            <span className={`${styles.shimmer} ${styles.leaseCardLineShort}`} />
                        </div>
                        <div className={styles.leaseCard}>
                            <span className={`${styles.shimmer} ${styles.leaseCardTitle}`} />
                            <span className={`${styles.shimmer} ${styles.leaseCardLine}`} />
                            <span className={`${styles.shimmer} ${styles.leaseCta}`} />
                            <span className={`${styles.shimmer} ${styles.leaseCtaSecondary}`} />
                        </div>
                    </div>
                </div>
            </section>

            {/* Built for owners — mirrors BuiltForOwnersSection (centered + dashboard) */}
            <section className={styles.owners} aria-hidden="true">
                <span className={`${styles.shimmer} ${styles.ownersEyebrow}`} />
                <div className={`${styles.shimmer} ${styles.ownersTitle}`} />
                <span className={`${styles.shimmer} ${styles.ownersDesc}`} />
                <span className={`${styles.shimmer} ${styles.ownersCta}`} />
                <div className={`${styles.shimmer} ${styles.ownersDashboard}`} />
            </section>
        </div>;
}